<div *ngIf="partner">
  <div class="card mb-3" [title]="partner.partnerTitle">
    <img [src]="partner.imageBannerUrl" class="card-img-top" />
    <img [src]="partner.imageLogoUrl" class="card-img" />
    <div class="card-body">
      <div class="card-title">
        <h5 [fittext]="true" [maxFontSize]="20">
          {{ partner.partnerTitle }}
        </h5>
      </div>
      <div class="card-text">
        <div [fittext]="true" [maxFontSize]="14">{{ partner.address }}</div>
      </div>
    </div>
  </div>
</div>
